/* ----------------------------- Scroll to Top Button ----------------------------- */
// Scroll to Top Button Event
document.addEventListener('DOMContentLoaded', function() {
    // Get the Scroll to Top button
    const scrollToTopBtn = document.getElementById('scroll2top');

    // Show or hide the button based on the scroll position
    window.addEventListener('scroll', function() {
        if (window.scrollY > 300) {
            scrollToTopBtn.classList.add('scroll2top-show-button');
        } else {
            scrollToTopBtn.classList.remove('scroll2top-show-button');
        }
    });

    // Add click event to the button
    scrollToTopBtn.addEventListener('click', function(e) {
        e.preventDefault();
        smoothScrollToTop(1500); // Call the custom smooth scroll function with duration
    });

    /**
     * Smoothly scrolls back to the top of the page.
     * @param {number} duration - The duration of the scroll in milliseconds.
     */
    function smoothScrollToTop(duration) {
        const start = window.scrollY;
        const startTime = performance.now();

        function scrollAnimation(currentTime) {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1); // Limit progress to 1

            // Easing function for a smooth effect (easeInOutQuad)
            const ease = progress < 0.5
                ? 2 * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 2) / 2;

            // Calculate the current scroll position
            const scrollPosition = start - start * ease;

            // Scroll to the calculated position
            window.scrollTo(0, scrollPosition);

            // Continue the animation if not yet complete
            if (progress < 1) {
                requestAnimationFrame(scrollAnimation);
            }
        }

        requestAnimationFrame(scrollAnimation);
    }
});

/* ----------------------------- Search Box Typing Effect ----------------------------- */
document.addEventListener("DOMContentLoaded", function() {
  // Get the search input element
  const searchInput = document.querySelector('.js-search-input');
  
  // Get the hidden input that contains the placeholder texts
  const hiddenInput = document.getElementById("custom-searchbox-placeholder-texts");
  
  // Retrieve the value from the hidden input and split it into an array using commas, trimming any extra spaces
  const texts = hiddenInput.value.split(",").map(text => text.trim());

  let textIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  
  // Get the typing speeds and delays from data attributes or use default values
  const typingSpeed = parseInt(searchInput.dataset.typingSpeed) || 100;
  const deletingSpeed = parseInt(searchInput.dataset.deletingSpeed) || 60;
  const delayAfterWordTyped = parseInt(searchInput.dataset.delayAfterWordTyped) || 2400;
  const delayBeforeFirstDelete = parseInt(searchInput.dataset.delayBeforeFirstDelete) || 2000;
  const delayAfterDeleting = parseInt(searchInput.dataset.delayAfterDeleting) || 500;

  function typeEffect() {
    const currentText = texts[textIndex];
    
    if (!isDeleting) {
      // Write one more character
      charIndex++;
      searchInput.setAttribute("placeholder", currentText.substring(0, charIndex));
      
      if (charIndex === currentText.length) {
        // Word complete: wait before starting to delete
        isDeleting = true;
        setTimeout(typeEffect, delayBeforeFirstDelete);
        return;
      }
    } else {
      // Delete one character
      charIndex--;
      searchInput.setAttribute("placeholder", currentText.substring(0, charIndex));
      
      if (charIndex === 0) {
        // Finished deleting: move to the next text
        isDeleting = false;
        textIndex = (textIndex + 1) % texts.length;
        setTimeout(typeEffect, delayAfterDeleting);
        return;
      }
    }
    
    // Set the next call based on whether typing or deleting
    const timeout = isDeleting ? deletingSpeed : typingSpeed;
    setTimeout(typeEffect, timeout);
  }

  // Start the typing effect
  typeEffect();
});

/* ----------------------------- Tippy Tooltip ----------------------------- */
document.addEventListener("DOMContentLoaded", function() {
    tippy('.custom-tooltip', {
    content(reference) {
      return reference.getAttribute('title');
    },
    onMount(instance) {
      instance.reference.removeAttribute('title');
    },
    placement: 'bottom',
  });
});